<template>
  <div class="layout-position">
    <template v-if="sidebarPositionDetailIndex">
      <portal to="sidebar-position-detail-index">
        <SidebarPositionDetailIndex />
      </portal>
    </template>
    <template v-if="sidebarPositionDetailMapView">
      <portal to="sidebar-position-detail-map-view">
        <SidebarPositionDetailMapView />
      </portal>
    </template>
    <template v-if="sidebarPositionDetailIndexDeleted">
      <portal to="sidebar-position-detail-index-deleted">
        <SidebarPositionDetailIndexDeleted />
      </portal>
    </template>
    <template v-if="sidebarPositionDetailIndexStarred">
      <portal to="sidebar-position-detail-index-starred">
        <SidebarPositionDetailIndexStarred />
      </portal>
    </template>
    <template v-if="sidebarPositionDetailIndexPolygon">
      <portal to="sidebar-position-detail-index-polygon">
        <SidebarPositionDetailIndexPolygon />
      </portal>
    </template>
    <template v-if="activeFeature">
      <portal to="position-detail-feature-point">
        <PositionDetailFeaturePoint />
      </portal>
    </template>
    <template v-else>
      <portal to="position-detail-unselected">
        <PositionDetailUnselected />
      </portal>
    </template>
    <template v-if="modalReport">
      <portal to="simple-modal">
        <ModalReport />
      </portal>
    </template>
  </div>
</template>

<script>
import SidebarPositionDetailIndex from "@/components/Position/SidebarPositionDetailIndex.vue";
import SidebarPositionDetailIndexDeleted from "@/components/Position/SidebarPositionDetailIndexDeleted.vue";
import SidebarPositionDetailIndexStarred from "@/components/Position/SidebarPositionDetailIndexStarred.vue";
import SidebarPositionDetailIndexPolygon from "@/components/Position/SidebarPositionDetailIndexPolygon.vue";
import SidebarPositionDetailMapView from "@/components/Position/SidebarPositionDetailMapView.vue";
import PositionDetailUnselected from "@/components/Position/PositionDetailUnselected.vue";
import PositionDetailFeaturePoint from "@/components/Position/PositionDetailFeaturePoint.vue";
import ModalReport from "@/components/Position/ModalReport.vue";

export default {
  components: {
    SidebarPositionDetailIndex,
    SidebarPositionDetailMapView,
    SidebarPositionDetailIndexDeleted,
    SidebarPositionDetailIndexStarred,
    SidebarPositionDetailIndexPolygon,
    PositionDetailUnselected,
    PositionDetailFeaturePoint,
    ModalReport
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.appAsset ? this.appAsset.color_primary : "#6DCC00",
          vmid: "theme-color"
        }
      ]
    };
  },
  computed: {
    appAsset() {
      return this.activePosition.gemeente.app_asset
        ? this.activePosition.gemeente.app_asset
        : null;
    },
    activePosition() {
      return this.$store.state.ui.activePosition;
    },
    sidebarPositionDetailIndex() {
      return this.$store.state.ui.sidebarPositionDetailIndex;
    },
    sidebarPositionDetailIndexDeleted() {
      return this.$store.state.ui.sidebarPositionDetailIndexDeleted;
    },
    sidebarPositionDetailIndexStarred() {
      return this.$store.state.ui.sidebarPositionDetailIndexStarred;
    },
    sidebarPositionDetailIndexPolygon() {
      return this.$store.state.ui.sidebarPositionDetailIndexPolygon;
    },
    sidebarPositionDetailMapView() {
      return this.$store.state.ui.sidebarPositionDetailMapView;
    },
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    modalReport() {
      return this.$store.state.ui.modalReport;
    }
  },
  methods: {
    closeModalReport() {
      this.$store.commit("closeModalReport");
    }
  }
};
</script>

<style scoped lang="scss">
.layout-position {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
}
</style>
